// Clinical Database — neurological patterns and their examination sections
const CLINICAL_DATABASE = {
  "UMN Pattern": {
  color: "#6366f1",
  icon: "🧠",
  region: "Upper Motor Neuron",
  sections: [
    {
      title: "Observation",
      fields: [
        { key: "attitude", label: "Limb Attitude", type: "multi", options: ["Flexor synergy (UL)", "Extensor synergy (LL)", "Hemiplegic posture", "Decorticate", "Decerebrate", "Spastic quadriplegia", "Spastic diplegia", "Scissoring", "Early flaccid stage", "Associated reactions", "Mass synergy", "Contracture posture", "Equinus", "Equinovarus", "Trunk asymmetry", "Asymmetrical limb involvement", "Postural fixation", "Task-dependent abnormal posture"] },
        { key: "built", label: "Built", type: "multi", options: ["Normal (early)", "Lean / reduced bulk", "Asymmetrical build", "Generalized stiffness", "Wasted appearance"] },
        { key: "postureObs", label: "Posture", type: "multi", options: ["Spastic hemiplegic posture", "Flexor UL + extensor LL", "Decorticate / Decerebrate", "Quadriplegic / Diplegic posture", "Scissoring", "Trunk asymmetry", "Forward flexed trunk", "Pelvic tilt / rotation", "Fixed posture"] },
        { key: "gaitObs", label: "Gait", type: "multi", options: ["Spastic gait", "Hemiplegic (circumduction)", "Scissoring gait", "Stiff-legged", "Toe drag", "Reduced arm swing", "Knee hyperextension", "Slow cautious", "Assisted / Non-ambulatory"] },
        { key: "movementPattern", label: "Movement Pattern", type: "multi", options: ["Synergy-dominated", "Mass movement", "Loss of selective control", "Associated reactions", "Overflow movements", "Reduced fractionation", "Slow, stiff, effortful", "Poor timing", "Reduced coordination"] },
        { key: "otherObs", label: "Other Observations", type: "multi", options: ["Ventilation abnormal", "Respiration abnormal", "Oedema", "Muscle wasting", "Pressure sores", "Deformity", "Wounds", "External appliances"] }
      ]
    },
    {
      title: "Palpation",
      fields: [
        { key: "warmth", label: "Skin Temperature", type: "single", options: [
          "Normal", "Local warmth (inflammation)", "Bilateral warmth", "Cool / reduced circulation"
        ]},
        { key: "skinTexture", label: "Skin & Soft Tissue", type: "multi", options: [
          "Normal skin texture", "Dry / scaly skin", "Oedematous skin", "Pitting oedema",
          "Non-pitting oedema", "Trophic changes", "Pressure sore / ulceration",
          "Callus formation", "Maceration (moisture)", "Tight / bound skin"
        ]},
        { key: "tenderness", label: "Tenderness", type: "single", options: [
          "Absent", "Mild", "Moderate", "Severe"
        ]},
        { key: "tendernessLocation", label: "Tenderness Location", type: "multi", options: [
          "Muscle belly tenderness", "Joint tenderness", "Tendon tenderness",
          "Bony prominence tenderness", "Peripheral nerve tenderness",
          "Spinal / paraspinal tenderness", "Trigger point tenderness"
        ]},
        { key: "tonePalpation", label: "Muscle Tone (Palpated)", type: "multi", options: [
          "Normal resting tone", "Hypotonia (flaccid)", "Mild spasticity",
          "Moderate spasticity", "Severe spasticity", "Clasp-knife response",
          "Flexor dominance (UL)", "Extensor dominance (LL)",
          "Velocity-dependent resistance", "Rigidity (non-velocity dependent)"
        ]},
        { key: "toneDistribution", label: "Tone Distribution", type: "multi", options: [
          "Unilateral (hemiplegia)", "Bilateral UL", "Bilateral LL",
          "Quadriplegic pattern", "Diplegic pattern",
          "Proximal predominant", "Distal predominant"
        ]},
        { key: "muscleConsistency", label: "Muscle Consistency", type: "multi", options: [
          "Normal", "Soft / atrophic", "Hard / hypertrophic",
          "Fibrotic / indurated", "Ropey / band-like",
          "Fasciculations palpable", "Clonus elicitable on palpation"
        ]},
        { key: "contracture", label: "Contracture / Tightness", type: "multi", options: [
          "None", "Mild tightness", "Moderate contracture",
          "Fixed contracture", "Elbow flexion contracture",
          "Wrist flexion contracture", "Finger flexion contracture",
          "Hip flexion contracture", "Knee flexion contracture",
          "Ankle plantarflexion contracture (equinus)", "Equinovarus"
        ]},
        { key: "jointPalpation", label: "Joint Status", type: "multi", options: [
          "No joint abnormality", "Joint effusion", "Periarticular swelling",
          "Subluxation palpable", "Shoulder subluxation (hemiplegic)",
          "Hip subluxation", "Reduced joint mobility on passive movement",
          "Crepitus on movement", "Hypermobility (flaccid phase)"
        ]},
        { key: "swelling", label: "Swelling / Oedema", type: "single", options: [
          "None", "Mild dependent oedema", "Moderate oedema",
          "Severe oedema", "Hand oedema", "Foot / ankle oedema",
          "Generalized limb oedema"
        ]},
        { key: "swellingCharacter", label: "Swelling Character", type: "multi", options: [
          "Pitting", "Non-pitting", "Soft / mobile",
          "Firm / brawny", "Localized", "Diffuse"
        ]},
        { key: "painOnPassiveStretch", label: "Pain on Passive Stretch", type: "single", options: [
          "Absent", "Mild discomfort", "Moderate pain", "Severe pain / guarding"
        ]},
        { key: "deepTissue", label: "Deep Tissue / Bony Landmarks", type: "multi", options: [
          "Normal", "Spinal deformity palpable", "Bony prominences at risk",
          "Heterotopic ossification (suspected)", "Crepitus at joint",
          "Atrophic muscle pad over bony prominence"
        ]}
      ]
    },
    { title: "Cognition (MMSE)", fields: [
  { key: "mmseData", label: "MMSE Scoring", type: "mmse" }
  ]
  },
    { title: "Cranial Nerves", fields: [
  { key: "cranialData", label: "Cranial Nerve Assessment", type: "cranial" }
    ]
},
    {
      title: "Sensory System",
      fields: [{ key: "sensoryData", label: "Sensory Assessment", type: "sensory" }
      ]
    },
    {
      title: "Motor System",
      fields: [
        { key: "voluntaryControlData", label: "Voluntary Control", type: "voluntary" },
        { key: "romData", label: "Range Of Motion", type: "rom" },
        { key: "tone", label: "Muscle Tone", type: "multi", options: ["Normal", "Hypotonia", "Spasticity", "Clasp-knife", "Rigidity", "Severe spasticity", "Contracture"] },
        { key: "mmt", label: "MMT Pattern", type: "multi", options: ["Normal", "Pyramidal pattern", "Flexors stronger (UL)", "Extensors stronger (LL)"] }
      ]
    },
    {
      title: "Reflexes",
      fields: [{ key: "reflexData", label: "Reflex Assessment", type: "reflex" }]
    },
    {
      title: "Coordination & Balance",
      fields: [{ key: "coordinationData", label: "Coordination Assessment", type: "coordination" }]
    },
    {
      title: "Posture",
      fields: [{ key: "postureData", label: "Postural Assessment", type: "posture" }]
    },
    {
      title: "Gait Analysis (Detailed)",
      fields: [{ key: "gaitData", label: "Gait Analysis", type: "gait" }]
    },
    {
      title: "Hand Function",
      fields: [{ key: "handData", label: "Hand Function Assessment", type: "hand" }]
    },
    {
      title: "Systems Review",
      fields: [{ key: "systemsData", label: "Systems Review", type: "systems" }]
    },
    { title: "Functional Assessment", fields: [{ key: "fimData", label: "FIM Assessment", type: "fim" }] }
  ]
},
  "LMN Pattern": {
    color: "#10b981",
    icon: "🦴",
    region: "Lower Motor Neuron",
    sections: [
      {
        title: "Observation",
        fields: [
          { key: "attitude", label: "Limb Attitude", type: "multi", options: ["Flaccid limb", "Limp / hanging limb", "No resistance to gravity", "Dependent positioning", "Wrist drop", "Foot drop", "Claw hand", "Ape thumb", "Segmental deformity", "Proximal weakness posture", "Fasciculations visible"] },
          { key: "built", label: "Built", type: "multi", options: ["Reduced muscle bulk", "Marked asymmetry", "Localized wasting", "Generalized wasting", "Thin frail appearance"] },
          { key: "postureObs", label: "Posture", type: "multi", options: ["Floppy posture", "Collapsed posture", "Poor postural control", "Asymmetrical alignment", "Joint instability", "No spastic fixation"] },
          { key: "gaitObs", label: "Gait", type: "multi", options: ["Steppage gait", "Slapping gait", "High stepping", "Waddling gait", "Foot drag", "Instability", "Assisted / non-ambulatory"] },
          { key: "movementPattern", label: "Movement Pattern", type: "multi", options: ["Isolated weakness", "Reduced force generation", "Poor power output", "Fatigable", "Irregular due to weakness", "No mass pattern"] },
          { key: "respiration", label: "Respiration", type: "multi", options: ["Normal", "Shallow", "Reduced chest expansion", "Diaphragmatic dominance", "Paradoxical breathing", "Weak cough"] },
          { key: "otherObs", label: "Other Findings", type: "multi", options: ["Oedema", "Muscle wasting severe", "Pressure sores", "Flail", "Subluxation", "Clawing", "Foot drop", "Muscle imbalance", "Contracture", "Wounds", "Appliances"] }
        ]
      },
      {
        title: "Palpation",
        fields: [
          { key: "warmth", label: "Warmth", type: "single", options: ["Normal", "Increased"] },
          { key: "tenderness", label: "Tenderness", type: "single", options: ["Absent", "Localized"] },
          { key: "tonePalpation", label: "Tone", type: "multi", options: ["Hypotonia", "Flaccidity", "No resistance", "No velocity dependence"] },
          { key: "swelling", label: "Swelling", type: "single", options: ["None", "Dependent", "Chronic"] }
        ]
      },
      {
        title: "Muscle Girth",
        fields: [
          { key: "girth_upper_arm", label: "Upper Arm (Biceps region)", type: "single", options: ["Normal", "Mild atrophy", "Moderate atrophy", "Severe atrophy", "Asymmetry (R < L)", "Asymmetry (L < R)"] },
          { key: "girth_forearm", label: "Forearm", type: "single", options: ["Normal", "Mild atrophy", "Moderate atrophy", "Severe atrophy", "Asymmetry (R < L)", "Asymmetry (L < R)"] },
          { key: "girth_hand_thenar", label: "Thenar / Hypothenar (Hand)", type: "single", options: ["Normal", "Thenar wasting", "Hypothenar wasting", "Intrinsic wasting", "Bilateral wasting"] },
          { key: "girth_thigh", label: "Thigh (Quadriceps region)", type: "single", options: ["Normal", "Mild atrophy", "Moderate atrophy", "Severe atrophy", "Asymmetry (R < L)", "Asymmetry (L < R)"] },
          { key: "girth_calf", label: "Calf (Gastrocnemius region)", type: "single", options: ["Normal", "Mild atrophy", "Moderate atrophy", "Severe atrophy", "Asymmetry (R < L)", "Asymmetry (L < R)"] },
          { key: "girth_distribution", label: "Pattern of Wasting", type: "multi", options: ["No wasting", "Distal predominant", "Proximal predominant", "Diffuse / generalized", "Segmental", "Unilateral", "Bilateral symmetric", "Bilateral asymmetric"] },
          { key: "girth_fasciculations", label: "Visible Fasciculations", type: "single", options: ["Absent", "Present – upper limb", "Present – lower limb", "Present – trunk", "Present – generalized"] }
        ]
      },
      { title: "Cranial Nerves", fields: [
      { key: "cranialData", label: "Cranial Nerve Assessment", type: "cranial" }
      ]
      },
      
      {
        title: "Motor System",
        fields: [
          { key: "voluntaryControlData", label: "Voluntary Control", type: "voluntary" },
          { key: "mmt", label: "MMT Pattern", type: "multi", options: ["Grade 0–5 weakness pattern"] }
        ]
      },
      {
        title: "ROM",
        fields: [{ key: "romData", label: "Range Of Motion", type: "rom" }]
      },
      {
        title: "Reflexes",
        fields: [{ key: "reflexData", label: "Reflex Assessment", type: "reflex" }]
      },
      {
        title: "Involuntary Movements",
        fields: [
          { key: "involuntary_presence", label: "Presence", type: "single", options: ["None", "Present"] },
          { key: "involuntary_type", label: "Movement Type", type: "multi", options: ["Fasciculations", "Fibrillations", "Spasms (flexor)", "Spasms (extensor)", "Tremor (resting)", "Myoclonus", "Tics", "Chorea", "Dystonia", "Athetosis"] },
          { key: "involuntary_distribution", label: "Distribution", type: "multi", options: ["Focal", "Segmental", "Generalized", "Upper limb", "Lower limb", "Trunk", "Face"] },
          { key: "involuntary_trigger", label: "Trigger / Pattern", type: "multi", options: ["At rest", "With movement", "With fatigue", "Spontaneous", "Stimulus-sensitive", "Continuous", "Intermittent"] }
        ]
      },
      {
        title: "Systems Review",
        fields: [{ key: "systemsData", label: "Systems Review", type: "systems" }]
      },
      { title: "Functional Assessment", fields: [{ key: "fimData", label: "FIM Assessment", type: "fim" }] }
    ]
  },
  "Cerebellar": {
    color: "#8b5cf6",
    icon: "⚖️",
    region: "Hindbrain / Coordination",
    sections: [
      {
        title: "Observation",
        fields: [
          { key: "attitude", label: "Limb Attitude", type: "multi", options: ["No fixed abnormal posture", "Hypotonic limbs", "Pendular positioning", "Dysmetria posture", "Intention errors", "Tremor", "No synergy pattern"] },
          { key: "built", label: "Built", type: "multi", options: ["Normal build", "No primary wasting", "Mild disuse changes"] },
          { key: "postureObs", label: "Posture", type: "multi", options: ["Swaying posture", "Wide base stance", "Difficulty upright posture", "Truncal ataxia", "Titubation", "No spastic fixation"] },
          { key: "gaitObs", label: "Gait", type: "multi", options: ["Ataxic gait", "Wide-based gait", "Staggering gait", "Irregular step length", "Veering", "Cannot walk straight", "Difficulty turning", "Loss of balance", "Unable tandem"] },
          { key: "movementPattern", label: "Movement Pattern", type: "multi", options: ["Dysmetria", "Dysdiadochokinesia", "Intention tremor", "Decomposition", "Asynergy", "Poor timing", "Poor force control", "Incoordination"] },
          { key: "respiration", label: "Respiration", type: "multi", options: ["Normal", "Irregular"] },
          { key: "otherObs", label: "Other Findings", type: "multi", options: ["Oedema absent", "No muscle wasting", "Falls-related injury", "Deformity secondary", "Wounds", "Appliances"] }
        ]
      },
      {
        title: "Palpation",
        fields: [
          { key: "warmth", label: "Warmth", type: "single", options: ["Normal"] },
          { key: "tenderness", label: "Tenderness", type: "single", options: ["Absent", "Trauma-related"] },
          { key: "tonePalpation", label: "Tone", type: "multi", options: ["Normal", "Mild hypotonia", "Pendular tone"] },
          { key: "swelling", label: "Swelling", type: "single", options: ["Absent", "Secondary injury"] }
        ]
      },
      { title: "Cranial Nerves", fields: [
  { key: "cranialData", label: "Cranial Nerve Assessment", type: "cranial" }
    ]
    },
      {
        title: "Motor System",
        fields: [
          { key: "voluntaryControlData", label: "Voluntary Control", type: "voluntary" },
          { key: "tone", label: "Muscle Tone", type: "multi", options: ["Normal", "Hypotonia", "Mild flaccidity"] },
          { key: "mmt", label: "MMT", type: "multi", options: ["Normal strength", "Coordination-limited strength"] }
        ]
      },
      {
        title: "ROM",
        fields: [{ key: "romData", label: "Range Of Motion", type: "rom" }]
      },
      {
        title: "Coordination (Core)",
        fields: [{ key: "coordinationData", label: "Coordination Assessment", type: "coordination" }]
      },
      {
        title: "Involuntary Movements",
        fields: [
          { key: "involuntary_presence", label: "Presence", type: "single", options: ["None", "Present"] },
          { key: "involuntary_type", label: "Movement Type", type: "multi", options: ["Intention tremor", "Resting tremor", "Postural tremor", "Titubation (head / trunk)", "Myoclonus", "Chorea", "Athetosis", "Dystonia", "Tics", "Nystagmus"] },
          { key: "involuntary_distribution", label: "Distribution", type: "multi", options: ["Upper limb", "Lower limb", "Trunk", "Head / neck", "Face", "Bilateral", "Generalized"] },
          { key: "involuntary_trigger", label: "Trigger / Pattern", type: "multi", options: ["At rest", "During movement", "With target-directed movement", "Worsens with action", "Worsens with fatigue", "Stimulus-sensitive", "Continuous", "Intermittent"] }
        ]
      },
      {
        title: "Balance",
        fields: [{ key: "balanceData", label: "Balance Assessment", type: "balance" }]
      },
      {
        title: "Gait Analysis",
        fields: [{ key: "gaitData", label: "Gait Analysis", type: "gait" }]
      },
      {
        title: "Systems Review",
        fields: [{ key: "systemsData", label: "Systems Review", type: "systems" }]
      },
      { title: "Functional Assessment", fields: [{ key: "fimData", label: "FIM Assessment", type: "fim" }] }
    ]
  },
  "Sensory": {
    color: "#f59e0b",
    icon: "🌡️",
    region: "Peripheral / Proprioceptive",
    sections: [
      {
        title: "Observation",
        fields: [
          { key: "attitude", label: "Limb Attitude", type: "multi", options: ["Normal resting posture", "Protective posture", "Misplaced limb", "Unaware limb position", "Pseudo-athetosis", "No synergy / no flaccidity"] },
          { key: "built", label: "Built", type: "multi", options: ["Normal", "No primary wasting", "Mild disuse changes"] },
          { key: "postureObs", label: "Posture", type: "multi", options: ["Compensatory posture", "Visual dependency", "Instability without vision", "No spastic posture"] },
          { key: "gaitObs", label: "Gait", type: "multi", options: ["Stamping gait", "High stepping gait", "Slapping gait", "Wide base gait", "Worse in dark", "Vision-dependent walking", "Positive Romberg"] },
          { key: "movementPattern", label: "Movement Pattern", type: "multi", options: ["Inaccurate movement", "Misjudged force", "Poor joint position sense", "Slow cautious", "Improves with vision"] },
          { key: "otherObs", label: "Other Findings", type: "multi", options: ["Oedema", "No muscle wasting", "Pressure sores risk", "Charcot joint", "Wounds", "Appliances"] }
        ]
      },
      {
        title: "Palpation",
        fields: [
          { key: "warmth", label: "Warmth", type: "single", options: ["Normal", "Increased"] },
          { key: "tenderness", label: "Tenderness", type: "multi", options: ["Reduced", "Absent", "Delayed response"] },
          { key: "tonePalpation", label: "Tone", type: "multi", options: ["Normal", "Mild reduction", "No spasticity", "No flaccidity"] },
          { key: "swelling", label: "Swelling", type: "multi", options: ["Neuropathy-related", "Chronic oedema"] }
        ]
      },
      {
        title: "Sensory Testing (Core)",
        fields: [
          { key: "sens_superficial_pain", label: "Pain (Superficial)", type: "single", options: ["Normal", "Hypoalgesia", "Analgesia", "Hyperalgesia", "Allodynia", "Not tested"] },
          { key: "sens_temperature", label: "Temperature", type: "single", options: ["Normal", "Reduced", "Absent", "Impaired discrimination", "Not tested"] },
          { key: "sens_light_touch", label: "Light Touch", type: "single", options: ["Normal", "Reduced", "Absent", "Hyperesthesia", "Not tested"] },
          { key: "sens_pressure", label: "Deep Pressure", type: "single", options: ["Normal", "Reduced", "Absent", "Not tested"] },
          { key: "sens_vibration", label: "Vibration (128 Hz tuning fork)", type: "single", options: ["Normal", "Reduced", "Absent", "Not tested"] },
          { key: "sens_position", label: "Joint Position Sense (Proprioception)", type: "single", options: ["Normal", "Impaired", "Absent", "Not tested"] },
          { key: "sens_movement", label: "Movement Sense (Kinaesthesia)", type: "single", options: ["Normal", "Impaired", "Absent", "Not tested"] },
          { key: "sens_twopoint", label: "Two-Point Discrimination", type: "single", options: ["Normal", "Impaired", "Absent", "Not tested"] },
          { key: "sens_stereognosis", label: "Stereognosis", type: "single", options: ["Normal (Stereognosis intact)", "Astereognosis", "Not tested"] },
          { key: "sens_graphesthesia", label: "Graphesthesia", type: "single", options: ["Normal", "Agraphesthesia", "Not tested"] },
          { key: "sens_extinction", label: "Tactile Extinction / Double Simultaneous", type: "single", options: ["Normal (No extinction)", "Extinction present", "Not tested"] },
          { key: "sens_distribution", label: "Distribution of Loss", type: "multi", options: ["No deficit", "Glove and stocking", "Dermatomal", "Hemibody (right)", "Hemibody (left)", "Distal predominant", "Proximal predominant", "Dissociated loss", "Crossed pattern", "Generalized"] },
          { key: "sens_romberg", label: "Romberg Test", type: "single", options: ["Negative (Normal)", "Positive – sways with eyes closed", "Positive – falls with eyes closed", "Not tested"] },
          { key: "sens_special", label: "Special Sensory Findings", type: "multi", options: ["None", "Paresthesia", "Dysesthesia", "Burning pain", "Lancinating pain", "Hypersensitivity to touch", "Sensory ataxia pattern", "Pseudoathetosis"] }
        ]
      },
      {
        title: "Motor System",
        fields: [
          { key: "voluntaryControlData", label: "Voluntary Control", type: "voluntary" },
          { key: "tone", label: "Muscle Tone", type: "multi", options: ["Normal", "Mild reduction", "No spasticity", "No flaccidity"] },
          { key: "mmt", label: "MMT", type: "multi", options: ["Normal strength"] }
        ]
      },
      {
        title: "ROM",
        fields: [{ key: "romData", label: "Range Of Motion", type: "rom" }]
      },
      {
        title: "Reflexes",
        fields: [{ key: "reflexData", label: "Reflex Assessment", type: "reflex" }]
      },
      {
        title: "Coordination",
        fields: [{ key: "coordinationData", label: "Coordination Assessment", type: "coordination" }]
      },
      {
        title: "Equilibrium",
        fields: [
          { key: "equil_romberg", label: "Romberg Test", type: "single", options: ["Negative (Normal)", "Positive – sways with eyes closed", "Positive – falls with eyes closed", "Not tested"] },
          { key: "equil_standing_eo", label: "Standing – Eyes Open", type: "single", options: ["Normal", "Impaired", "Unable", "Not tested"] },
          { key: "equil_standing_ec", label: "Standing – Eyes Closed", type: "single", options: ["Normal", "Impaired", "Unable", "Not tested"] },
          { key: "equil_tandem", label: "Tandem Standing", type: "single", options: ["Normal", "Impaired", "Unable", "Not tested"] },
          { key: "equil_one_leg", label: "Single Leg Stand", type: "single", options: ["Normal bilaterally", "Impaired (Right)", "Impaired (Left)", "Impaired (Both)", "Unable", "Not tested"] },
          { key: "equil_tandem_walk", label: "Tandem Walking", type: "single", options: ["Normal", "Impaired", "Unable", "Not tested"] },
          { key: "equil_visual_dep", label: "Visual Dependency", type: "single", options: ["None (Normal)", "Mild – compensates with vision", "Marked – cannot balance without vision", "Not tested"] },
          { key: "equil_findings", label: "Additional Findings", type: "multi", options: ["No deficit", "Increased body sway", "Corrects with vision", "Falls without vision", "Steppage pattern", "Wide base compensation", "Truncal instability", "Postural tremor during stance"] }
        ]
      },
      {
        title: "Balance",
        fields: [{ key: "balanceData", label: "Balance Assessment", type: "balance" }]
      },
      {
        title: "Gait Analysis",
        fields: [{ key: "gaitData", label: "Gait Analysis", type: "gait" }]
      },
      {
        title: "Systems Review",
        fields: [{ key: "systemsData", label: "Systems Review", type: "systems" }]
      },
      { title: "Functional Assessment", fields: [{ key: "fimData", label: "FIM Assessment", type: "fim" }] }
    ]
  }
};

export default CLINICAL_DATABASE;
